import Providers from './app/Providers'
import Router from './app/Router'

function App() {
    return (
        <Providers>
            <Router />
        </Providers>
    )
}

export default App
